module.exports = __webpack_public_path__ + "static/media/ayuda.b19dfb17.svg";